// extracted by mini-css-extract-plugin
export default {"rating":"dB-z","numberOfStars":"eB-z","count":"fB-z","barGraphSpacing":"gB-z","barGraph":"hB-z"};